// extracted by mini-css-extract-plugin
module.exports = {"grid":"_4e28357c","isVisible":"_9eac1010","headingContainer":"_248aa2cb","title":"_d0d18e4","subheadingContainer":"_736a5cef","subtitle":"_a6243860"};